import { lazy, Suspense } from "react";
import "./common.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "./components/Loader";
import { useSelector } from "react-redux";
import Loading from "./components/Loading";
import Snackback from "./components/Snackback";
const App = () => {
  const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
  const Login = lazy(() => import("./pages/login/Login"));
  const { Admin } = useSelector((state) => state.admin);
  return (
    <BrowserRouter>
      <Loading />
      <Snackback />
      <Routes>
        <Route
          path="/"
          exact
          element={
            Admin ? (
              <Suspense fallback={<Loader />}>
                <Dashboard />
              </Suspense>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          exact
          path="/login"
          element={
            <Suspense fallback={<Loader />}>
              <Login />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
